  <app-header-component></app-header-component>
  @if (isBrowser()) {
    <app-mobile-cart-bar></app-mobile-cart-bar>
  }
  <router-outlet></router-outlet>
  <app-footer-component></app-footer-component>

